/* eslint-disable @typescript-eslint/no-explicit-any */
import { nativeBr } from "./nativeBr"

/**
 * Dfinery 이벤트 파라미터 타입
 */
export interface DfineryEventParams {
  [key: string]: any
}

export type DfinerySourceType = "BOOK" | "MUSIC" | "MOVIE"
export type DfinerySourceTypeLabel = "도서" | "음악/영화"

const DFINERY_SOURCE_TYPE_LABEL_MAP: Record<
  DfinerySourceType,
  DfinerySourceTypeLabel
> = {
  BOOK: "도서",
  MUSIC: "음악/영화",
  MOVIE: "음악/영화",
}

export const toDfinerySourceTypeLabel = (
  type: DfinerySourceType,
): DfinerySourceTypeLabel => DFINERY_SOURCE_TYPE_LABEL_MAP[type]

/**
 * Dfinery 이벤트명
 */
export type DfineryEventName =
  | "lib_click_gnb" // GNB 클릭
  | "lib_click_quicklink" // 퀵링크 클릭
  | "lib_agree_intro" // 서재 이용 동의
  | "lib_bn_monthly" // 이달의서재 배너 클릭
  | "lib_bn_chips" // 문장칩 배너 클릭
  | "lib_add_book" // 도서 등록
  | "lib_join_challenge" // 챌린지 신청
  | "lib_write" // 문장 기록 완료
  | "lib_click_source" // 문장 출처 클릭
  | "lib_click_todaypick" // 오늘의 문장 클릭
  | "lib_join_kyobobook" // 교보문고 구매 연동 신청/해제 완료
  | "lib_bn_haru" // 하루잇문학 배너 클릭
  | "lib_bn_event" // 이벤트 새소식 배너 클릭
  | "lib_view_home" // 서재 홈 진입
  | "lib_view_search" // 통합 검색 진입
  | "lib_click_searchprofile" // 프로필 검색 결과 클릭
  | string // 확장 가능

/**
 * Dfinery 이벤트 로깅 (Native Bridge 사용)
 */
export const logDfineryEvent = async (
  eventName: DfineryEventName,
  attrModel?: DfineryEventParams,
): Promise<void> => {
  if (typeof window === "undefined") return

  try {
    // 네이티브 환경에서만 실제 전송
    if (nativeBr.isEnabled) {
      await nativeBr.dfineryLogEvent({
        eventName,
        attrModel: attrModel || {},
      })
    } else {
      // 웹 환경에서는 콘솔 로그만 (개발용)
      console.log("[Dfinery]", eventName, attrModel)
    }
  } catch (error) {
    console.error("[Dfinery] logEvent 실패:", error)
  }
}
